import React from 'react';
import {scheduledDate} from '../../utils/banTypeClassifier';
import {buildUrlAndOpenWindow} from 'app/utilities/StringHelpers/StringHelpers';
import BanPaymentMethodRow from './BanPaymentMethodRow';
import Image from 'app/Components/Shared/Image/image';

const PaidBanStatus = ({banData, yDaysCount}) => {
  return (
    <div className={`active-ban-status`}>
      <BanPaymentMethodRow banData={banData} />
      <div className='ban-status-card__section-divider' />
      <div className='active-ban-status__content'>
        <div className='active-ban-status__info'>
          <div className='active-ban-status__paid-label'>
            <span>
              <Image src={require('../../images/check.svg')} alt='checked' />
            </span>
            <span>החשבון שולם</span>
          </div>
          <div
            dangerouslySetInnerHTML={{__html: scheduledDate(banData, yDaysCount)}}
            className='scheduled-payment-ban-status__debt-label '
          />
          {banData.invoiceUrl && (
            <div className='invoice-link'>
              <div type='button' className='link' onClick={() => buildUrlAndOpenWindow(banData.invoiceUrl)}>
                לצפייה בחשבוניות אחרונות
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaidBanStatus;
